import localizationEnUsHeader from "./en-us/header.json";
import localizationEnUsContent from "./en-us/content.json";
import localizationEnUsModalReview from "./en-us/modal-review.json";
import localizationEnUsAdditionalData from "./en-us/additional-data.json";

export const localizationEnUsProduct = {
  ...localizationEnUsHeader,
  ...localizationEnUsContent,
  ...localizationEnUsModalReview,
  ...localizationEnUsAdditionalData,
};
